import { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

// helpers
import { groupBy } from '../../helpers/general'

// actions
import { getUsers as fetchUsers } from '../../store/actions/users'

// selectors
import { getFilteredUsers } from '../../store/selectors/users'

const useUsers = () => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const users = useSelector(getFilteredUsers)
  const getUsers = async (searchText = '') => {
    try {
      setIsLoading(true)
      const trimmedText = searchText.trim()
      const res = await dispatch(fetchUsers(trimmedText)).unwrap()
      const usersResource = res.resources
      if (usersResource.length === 0) {
        toast.error(t('no-matching-records'))
      }
    } catch (error) {
      toast.error(error?.message)
    } finally {
      setIsLoading(false)
    }
  }

  const usersById = useMemo(() => groupBy(users, 'id'), [users])

  return { users, areUsersLoading: isLoading, getUsers, usersById }
}

export default useUsers
